import { createContext } from 'react'

export const TimeZone = createContext(null)
